import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'

import { form } from '../../formState'
import { useTexts } from './useTexts'

export function BarcodeAttachment() {
  const texts = useTexts()

  const { userType } = useSelector(selectUserConfiguration)
  const rmOnlyAccount = userType === 'rmOnly'

  if (rmOnlyAccount) return null

  return (
    <form.Checkbox
      name="barcodeAttachmentAllowed"
      testId="barcodeAttachmentAllowed"
      label={texts.addNewBarcodes}
      validateOn="change"
      helperText={texts.addNewBarcodesHelperText}
    />
  )
}
